import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';
import Btn020 from 'dc/Btn020';

export const Wrapper = styled.div`
  width: 100%;
  border-top: 1px solid #eceff1;
  padding-top: 19px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled(Typ20)`
  width: 220px;
  text-align: center;
  margin-bottom: 10px;
`;

export const Button = styled(Btn020)`
  width: 100%;
  span {
    color: #d32e2e;
  }
`;
